import './HistogramSlider.74e0bc66a6aa13291238b3a5c88891bf.css';
export default {"bars":"_bars_filiy_1","bar":"_bar_filiy_1","active":"_active_filiy_1"};